// Story 7.6 — youtube_short card. Thin wrapper over the shared ClipCard.

import { ClipCard } from "./ClipCard";
import type { FeedCard } from "./useFeed";

export function YoutubeShortCard({ card }: { card: FeedCard }) {
  return <ClipCard card={card} />;
}
